export enum LandingPageOption {
  LinkCard = 'LinkCard',
  CreateCard = 'CreateCard',
}

export interface LandingPageFormValues {
  linkOrCreate: LandingPageOption | ''
}
